import request from '@/utils/request'; // 获取列表

export function fetchManageList(data) {
  return request({
    url: '/pmsservice/api/partyContent/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/partyContent/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/partyContent/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/partyContent/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/partyContent/update',
    method: 'post',
    data: data
  });
}
export function fetchClassList(data) {
  return request({
    url: '/pmsservice/api/partyContent/update',
    method: 'post',
    data: data
  });
}
export function fetchDetailForManage(data) {
  return request({
    url: '/pmsservice/api/partyContent/update',
    method: 'post',
    data: data
  });
}
export function fetchReadList(data) {
  return request({
    url: '/pmsservice/api/partyContent/readerList',
    method: 'post',
    data: data
  });
}
export function fetchRelease(data) {
  return request({
    url: '/pmsservice/api/partyContent/contentPublish',
    method: 'post',
    data: data
  });
}